export default __webpack_public_path__ + "static/media/ltc.b4964226.svg";